import { useEffect, useState } from 'react';
let cachedFlags = null;
const listeners = new Set();
export const normalizeFeatureFlags = (payload) => {
    if (!payload)
        return null;
    if (typeof payload === 'string') {
        try {
            return normalizeFeatureFlags(JSON.parse(payload));
        }
        catch {
            return null;
        }
    }
    if (typeof payload === 'object') {
        const record = payload;
        if (record.features && typeof record.features === 'object') {
            return record.features;
        }
        return record;
    }
    return null;
};
export const setFeatureFlags = (flags) => {
    cachedFlags = flags;
    listeners.forEach(listener => listener(cachedFlags));
};
export const useFeatureFlags = () => {
    const [flags, setFlags] = useState(cachedFlags);
    useEffect(() => {
        listeners.add(setFlags);
        return () => {
            listeners.delete(setFlags);
        };
    }, []);
    return flags;
};
export const getFeatureFlag = (flags, key, defaultValue = true) => {
    if (!flags || typeof flags !== 'object') {
        return defaultValue;
    }
    const value = flags[key];
    return typeof value === 'boolean' ? value : defaultValue;
};
